import { Badge } from "@hakistudio/hakiui";
import { differenceInCalendarDays, parseISO } from "date-fns";

/**
 * How urgent an expiry date is.
 *
 * Calendar days, not elapsed hours: something that goes off tomorrow morning
 * should read "tomorrow" all through tonight.
 */
export function expiryDays(expiresAt: string | null): number | null {
  if (!expiresAt) return null;
  return differenceInCalendarDays(parseISO(expiresAt), new Date());
}

export function ExpiryBadge({ expiresAt }: { expiresAt: string | null }) {
  const days = expiryDays(expiresAt);
  if (days === null) return null;

  if (days < 0) return <Badge size="sm" color="danger" variant="soft">Expired</Badge>;
  if (days === 0) return <Badge size="sm" color="danger" variant="soft">Today</Badge>;
  if (days === 1) return <Badge size="sm" color="warning" variant="soft">Tomorrow</Badge>;
  if (days <= 3) return <Badge size="sm" color="warning" variant="soft">{days} days</Badge>;
  return <Badge size="sm" color="neutral" variant="soft">{days} days</Badge>;
}
